import React, { useEffect, useRef } from 'react';

import { useSelector } from 'react-redux';

import { TABS_COUNT } from './constants';
import { MobilePredictionPanel } from './MobilePredictionPanel';
import { MobilePredictionPanelContainerProps } from './types';
import { getStackedIndex } from './utils';
import { CONTENT_ITEMS } from '../../../../../constants/Content';
import { useRouter } from '../../../../../hooks/useRouter';
import { selectContent, selectHandler } from '../../../../../store/routerSlice/routerSelectors';

const MobilePredictionPanelContainer: React.FC<MobilePredictionPanelContainerProps> = (props) => {
  const router = useRouter();

  const content = useSelector(selectContent);
  const handler = useSelector(selectHandler);

  const predictionContentRef = useRef<HTMLDivElement>(null);

  let showedStackedIndex = getStackedIndex(content);

  const [showedAbout, setShowedAbout] = React.useState<{index: number; type: string | null}>({
    index: 0,
    type: null
  });
  const [showed, setShowed] = React.useState<{index: number; type: string | null}>({
    index: 0,
    type: null
  });
  const [showedStacked, setShowedStacked] = React.useState<{index: number; isBack: boolean}>({
    index: showedStackedIndex,
    isBack: true
  });

  const initialState = new Array(TABS_COUNT).fill('none');
  initialState[0] = 'flex';
  const [displaies, setDisplaies] = React.useState(initialState);

  useEffect(() => {
    const newDisplaies = [...displaies];
    newDisplaies[showed.index] = 'flex';
    setDisplaies(newDisplaies);
  }, [showed]);

  const handleAboutTab = () => {
    if (showed.index === 0) {
      setShowedAbout({
        index: 0,
        type: 'back'
      });
      router.forward({
        content: CONTENT_ITEMS.ABOUT_US
      });
    }
  };

  const handlePredictionTab = () => {
    if (showed.index === 1) {
      router.back(); // Только для такой структуры
    }
  };

  const needShowHeaderBack = (content === CONTENT_ITEMS.ABOUT_US && showedAbout.index !== 0) || (content !== CONTENT_ITEMS.PREDICTION);

  const handleBack = () => {
    router.back();
  };

  useEffect(() => {
    if (content === CONTENT_ITEMS.ABOUT_US) {
      setShowed({ index: 1, type: handler === 'none' ? 'forward' : handler });
      setShowedAbout({
        type: handler === 'none' ? 'forward' : handler,
        index: 0,
      });
    } else {
      setShowed({ index: 0, type: handler === 'none' ? 'forward' : handler });
      setShowedStacked({
        isBack: handler === 'back',
        index: getStackedIndex(content)
      });
    }
  }, [content, handler]);

  return (
    <MobilePredictionPanel
      needShowHeaderBack={needShowHeaderBack}
      handleBack={handleBack}
      showed={showed}
      handlePredictionTab={handlePredictionTab}
      handleAboutTab={handleAboutTab}
      displaies={displaies}
      showedStacked={showedStacked}
      predictionContentRef={predictionContentRef}
      {...props}
    />
  );
};

export default MobilePredictionPanelContainer;
